module.exports = __webpack_public_path__ + "static/media/natour-site-min.8ca99a65.png";